import { useMemo } from "react";
import { Helmet } from "react-helmet";

const LoadDynamicIndexHead = (props: any) => {
    const appState = useMemo(() => props.appState, [props.appState]);
    const indexHead = appState.appStore.QueryStringParams.indexHead
    const metaData = indexHead?.metaData;
    const scriptData = indexHead?.scriptData;
    const linkData = indexHead?.linkData;
    const titleText = indexHead?.titleText;
    return (
        <Helmet>
            {/* title tag  */}

            {
                titleText && <title>{titleText}</title>
            }

            {/* Meta tag  */}
            {
                metaData && Array.isArray(metaData) && metaData.map((res: any) => {
                    return (
                        <meta {...res} />
                    )
                })
            }

            {/* script tag  */}

            {
                scriptData && Array.isArray(scriptData) && scriptData.map((res: any) => {
                    return (
                        <script {...res} />
                    )
                })
            }

            {/* link tag  */}

            {
                linkData && Array.isArray(linkData) && linkData.map((res: any) => {
                    return (
                        <link {...res} />
                    )
                })
            }



        </Helmet>
    )
};

export default LoadDynamicIndexHead;